import {ArticleDto} from "../model/invoice/ArticleDto";
import {Nil} from "./Types";


export const articleDescription = (code: string | null | undefined, dtos: ArticleDto[]) => {
    if (code) {
        //hack for the merit as it allows UOM selected in article
        const found = dtos.find(it => it.code === code || code.startsWith(it.code + "+"));
        if (found) {
            return found.description;
        }
    }
    return code;
}

export const findNameByCode = (code: string | Nil, dtos: { code: string, name: string }[]) => {
    const obj = dtos.find(it => it.code === code);
    if (obj) {
        return obj.name;
    } else {
        return code;
    }
}